var DEFAULT_TEXT_ROTATION_ANGLE = 0;
var DEFAULT_ICON_ANCHOR_POSITION = [0.5, 0];
var DEFAULT_TEXT_ALIGN = 'center';
var LABEL_FILL_COLOR_KEY = 'labelFillColor';
var LABEL_FONT_KEY = 'labelFont';
var LABEL_TEXT_ALIGN_KEY = 'labelTextAlign';
var LABEL_STROKE_COLOR_KEY = 'labelStrokeColor';
var LABEL_STROKE_WIDTH_KEY = 'labelStrokeWidth';
var LABEL_TEXT_KEY = 'textLabel';
var LABEL_ROTATION_KEY = 'rotation';
export { DEFAULT_TEXT_ROTATION_ANGLE, DEFAULT_ICON_ANCHOR_POSITION, DEFAULT_TEXT_ALIGN, LABEL_FILL_COLOR_KEY, LABEL_FONT_KEY, LABEL_STROKE_COLOR_KEY, LABEL_STROKE_WIDTH_KEY, LABEL_TEXT_ALIGN_KEY, LABEL_TEXT_KEY, LABEL_ROTATION_KEY };